'use strict';

/**
 * Print controller
 */
export default [
    '$scope', '$uibModalInstance',
    (
        $scope, $modalInstance
    ) => {
        $scope.ok = ok;
        $scope.cancel = cancel;

        $scope.printableCharts = [
            'Статистика',
            'Сводная статистика',
            'Отраслевая принадлежность',
            'Этапы реализации проектов',
            'Проекты по этапам',
            'Количество созданных рабочих мест',
            'Общий объем инвестиций',
            'Планируемые налоговые поступления',
            'Структура инвестиций',
            //'Состав налоговых поступлений',
            'Территории реализуемых проектов',
            'Распределение проектов по менеджерам',
        ]
        .map((chart, index) => ({
            title: chart,
            isPrint: true,
            id: index
        }));

        function ok() {
            $modalInstance.close(
                $scope.printableCharts
                .filter(chart => chart.isPrint)
                .map(item => item.id)
            );
        }

        function cancel() {
            $modalInstance.dismiss();
        }

        function changePrintable(id) {
            $scope.printableCharts = angular.copy($scope.printableCharts.map(chart => {
                if (chart.id === id) {
                    chart.isPrint = !chart.isPrint;
                }

                return chart;
            }))
        }
    }
]